// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accountLockedWrapper":"Uw27Z"};